import { OrganizationApi } from '../../../api';
import { dispatch } from '../../../store';
import { useContainer } from '../../useContainer';
import { useEffect, useState } from 'react';
import { setOrganization as setOrganizationSlice } from '../../../store/slices/organization.slice';

const useHttpGetOrganizationByIdOnMount = (organizationId: string) => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [isOrganizationReady, setIsOrganizationReady] = useState<boolean>();

    useEffect(() => {
        const { exec, abort } = organizationApi.getOrganizationById({
            params: { organizationId },
            onSuccess: res => dispatch(setOrganizationSlice(res.body)),
            onError: error => error,
            onFinally: () => setIsOrganizationReady(true),
        });
        exec();
        return abort;
    }, [organizationId]);

    return { isOrganizationReady };
};

export default useHttpGetOrganizationByIdOnMount;
